import { useMutation, useQueryClient } from '@tanstack/react-query';
import { tradesService } from '@/services/trades/trades-service';
import { invalidateTradeAndPoolCaches } from './invalidate-trade-caches';
import type { AmendPayload } from '@/services/trades/amend-mapper';

/**
 * Amend a PENDING position's booked "numbers" via PATCH /positions/{id}/
 * (LR-478 quantity, widened in LR-484 to price/margin/rate/dates). Pass an
 * AmendPayload carrying ONLY the changed fields (see diffAmendPayload). Invalidates
 * the whole positions cache (tradesKeys.all) so the detail page, trades list and
 * MTM page all refetch — margin_price/contract_value/total_rate are recomputed
 * server-side on save, so the booked cash and rate stay consistent.
 */
export const useUpdatePosition = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: AmendPayload }) =>
      tradesService.updatePosition(id, payload),
    onSuccess: () => {
      // LR-586: an amend re-syncs the pool's booking posting.
      invalidateTradeAndPoolCaches(queryClient);
    },
  });
};
